module.exports = __webpack_public_path__ + "static/img/icon1-11.85989030.png";